import React, { useMemo } from 'react';
import styles from './wrapCVIReviewWidget.module.scss';
import getDisplayName from '../../getDisplayName';
import InputContainer from '../../Inputs/InputContainer/InputContainer';
import { Link } from 'react-router-dom';
import I18n from '../../I18n/I18n/I18n';
export default function wrapCVIReviewWidget(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var errorStyle = useMemo(function () {
      if (props.required) {
        return {
          fontStyle: 'italic'
        };
      } else {
        return {};
      }
    }, [props.required]);

    // checkbox lists will have empty array
    if (Array.isArray(props.value) ? props.value.length !== 0 : props.value) {
      return /*#__PURE__*/React.createElement(WrappedComponent, props);
    } else {
      // for checkbox lists, rjsf library isn't passing along the label
      var label = props.label || props.schema.title;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputContainer, Object.assign({}, props, {
        label: label,
        style: errorStyle,
        errorMsg: props.rawErrors && props.rawErrors[0]
      }), /*#__PURE__*/React.createElement("p", {
        className: styles.value
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.italics
      }, props.required ? /*#__PURE__*/React.createElement(I18n, {
        i18n: "@dm/components.cvi-review-form.missing-required-data"
      }) : /*#__PURE__*/React.createElement(I18n, {
        i18n: "@dm/components.cvi-review-form.missing-data"
      })), props.options.link && /*#__PURE__*/React.createElement(React.Fragment, null, ' - ', /*#__PURE__*/React.createElement(Link, {
        to: props.options.link
      }, props.required ? /*#__PURE__*/React.createElement(I18n, {
        i18n: "@dm/components.cvi-review-form.missing-required-data-link"
      }) : /*#__PURE__*/React.createElement(I18n, {
        i18n: "@dm/components.cvi-review-form.missing-data-link"
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "assistive-text"
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: {
          id: '@dm/cv-uploader.components.review.missing-data-link-sr-only',
          values: {
            field: label
          }
        }
      })))))));
    }
  };
  Wrapped.displayName = "WrapCVIReviewWidget(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}